angular.module("leanlaw").directive("llInvoiceFilter", [function () {
  return {
    restrict: "EA",
    scope: {
      range: "=",
      horizontal: "="
    },
    template: require("./views/filter.html")
  };
}]);